import React from 'react';
import { Switch } from './ui/switch';

const TanstackColumnsToggle = ({ table, columnVisibility, setColumnVisibility }) => {

    const handleCheckedChange = (key, value) => {
        setColumnVisibility({ ...columnVisibility, [key]: value });
    }

    return (
        <div className="grid grid-cols-2 gap-4 p-4">
            {table
                .getAllColumns()
                .filter((column) => column.getCanHide())
                .map((column) => {
                    return (
                        <div key={column.id} className="flex items-center justify-between md:flex-col lg:flex-row md:items-start lg:items-center md:gap-1">
                            <span className="capitalize md:max-w-[120px] md:truncate lg:max-w-none lg:whitespace-normal">{column.id}</span>
                            <Switch
                                checked={columnVisibility[column.id]}
                                onCheckedChange={(value) => handleCheckedChange(column.id, value)}
                                className="transition-all"
                            />
                        </div>
                    );
                })}
        </div>
    );
};


export default TanstackColumnsToggle;
